import { application } from './firestore/applications';
import { user } from './firestore/user';

export const db = {
  application,
  ...user,
};
